module.exports = __webpack_public_path__ + "static/media/55.9640dbf4.gif";